import React from 'react';

class Validator extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errors: [], isLengthError: false };
        this.handleError = this.handleError.bind(this);
        this.evaluateErrors = this.evaluateErrors.bind(this);
    }
    handleError(value) {
        this.props.handleError(value);
    }

    evaluateErrors(val) {
        if (this.props.enabled !== true) {
            return false;
        }

        var errors = [];
        var isLengthError = false;
        var name = this.props.name;
        var minLength = this.props.minLength;
        var minLengthNull = this.props.minLengthNull;
        var maxLength = this.props.maxLength;
        var regex = this.props.regex;

        if (this.props.required === true && !val && val !== false) {
            errors.push(name + " is required");
        }

        if (minLength && (!val || val.toString().length < minLength)) {
            errors.push(name + " has a minimum length of " + minLength);
        }

        if (minLengthNull && (val.toString().length < minLengthNull && !val.toString().length == "0")) {
            errors.push(name + " has a minimum length of " + minLengthNull);
            isLengthError = true;
        }

        if (maxLength && val && val.toString().length > maxLength) {
            errors.push(name + " has a maximum length of " + maxLength);
        }

        if (regex && val && !new RegExp(regex).test(val)) {
            errors.push(this.props.regexMessage);
        }

        if (this.props.handleError) {
            this.handleError(errors.length > 0);
        }

        this.setState({ errors: errors, isLengthError: isLengthError });

        return errors.length > 0;
    }

    render() {
        if (this.props.enabled !== true || !this.state.errors || this.state.errors.length === 0) {
            return <div></div>;
        }

        if (this.state.isLengthError == true) {
            return <div></div>;
        }

        if (this.state.errors.length === 1) {
            return <div className="alert alert-danger" style={{ marginBottom: 0 }}>{this.state.errors[0]}</div>;
        } else {
            return (<div className="alert alert-danger" style={{ marginBottom: 0 }}>Multiple validation errors occured:
                <ul>
                    {this.state.errors.map(a => <li>{a}</li>)}
                </ul>
            </div>
            );
        }
    }
}

class EmailValidator extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errors: [] };
        this.handleError = this.handleError.bind(this);
        this.evaluateErrors = this.evaluateErrors.bind(this);
    }

    handleError(value) {
        this.props.handleError(value);
    }

    evaluateErrors(val) {
        var errors = [];
        var name = this.props.name;
        var email =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>() \[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (this.props.required === true && !val && val !== false) {
            errors.push(name + " is required");
        }

        if (val && !new RegExp(email).test(val)) {
            errors.push("The value entered is not a valid email address");
        }

        if (this.props.handleError) {
            this.handleError(errors.length > 0);
        }

        this.setState({ errors: errors });

        return errors.length > 0;
    }

    render() {
        if (this.props.enabled !== true || !this.state.errors || this.state.errors.length === 0) {
            return <div></div>;
        }

        if (this.state.errors.length === 1) {
            return <div className="alert alert-danger" style={{ marginBottom: 0 }}>{this.state.errors[0]}</div>;
        } else {
            return (<div className="alert alert-danger" style={{ marginBottom: 0 }}>Multiple validation errors occured:
                <ul>
                    {this.state.errors.map(a => <li>{a}</li>)}
                </ul>
            </div>
            );
        }
    }
}

class PasswordValidator extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errors: [] };
        this.handleError = this.handleError.bind(this);
        this.evaluateErrors = this.evaluateErrors.bind(this);
    }

    handleError(value) {
        this.props.handleError(value);
    }

    evaluateErrors(val, confirm) {

        var errors = [];

        if (!val) {
            errors.push("Please enter a password");
        } else {
            if (val !== confirm) {
                errors.push("The passwords entered do not match");
            }

            if (val.length < 10) {
                errors.push("Password must be a minimum of 10 characters long");
            }

            if (val.length > 500) {
                errors.push("Password must be a maxium of 500 characters long");
            }

            const set = new Set(val.split(""));

            if (set.size < 4) {
                errors.push("Password must contain at least 4 different characters");
            }
        }

        this.setState({ errors: errors });

        return errors.length > 0;
    }

    render() {
        if (this.props.enabled !== true || !this.state.errors || this.state.errors.length === 0) {
            return <div></div>;
        }

        if (this.state.errors.length === 1) {
            return <div className="alert alert-danger" style={{ marginBottom: 0 }}>{this.state.errors[0]}</div>;
        } else {
            return (<div className="alert alert-danger" style={{ marginBottom: 0 }}>Multiple validation errors occured:
                <ul>
                    {this.state.errors.map(a => <li>{a}</li>)}
                </ul>
            </div>
            );
        }
    }
}

export { PasswordValidator, EmailValidator, Validator };


// WEBPACK FOOTER //
// ./src/Validation.jsx